export const isValidUrl = (url: any) => {
  if (!url) return false;
  const regex =
    /^(?:(?:https?|ftp):\/\/)?(?:www\.)?(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/.*)?$/;
  return url.match(regex);
};

export const generateIpfsUrl = (
  uri: string | null | undefined,
  gateway = 'https://ipfs.io/ipfs/'
): string | null => {
  if (!uri) return null;

  const trimmed = uri.trim();

  // Nếu đã là link gateway hợp lệ
  if (trimmed.startsWith(gateway)) {
    return trimmed;
  }

  // Nếu là ipfs://CID thì chuyển sang gateway
  if (trimmed.startsWith('ipfs://')) {
    const cid = trimmed.slice(7);
    if (!cid || /[^a-z0-9]/i.test(cid)) return null; // CID đơn giản validation
    return `${gateway}${cid}`;
  }
  // Không hợp lệ
  return null;
};

export const joinPath = (...parts: string[]) => {
  return parts
    .map((p, i) => {
      // Xóa dấu "/" đầu/cuối trừ phần đầu tiên
      if (i === 0) return p.replace(/\/+$/, '');
      return p.replace(/^\/+|\/+$/g, '');
    })
    .filter(Boolean)
    .join('/')
    .replace(/^([^/])/, '/$1'); // đảm bảo path bắt đầu bằng "/"
};

export const joinExternalUrl = (baseUrl: string, path: string) => {
  const normalizedBase = baseUrl.replace(/\/+$/, '');
  const normalizedPath = path.replace(/^\/+/, '');
  return `${normalizedBase}/${normalizedPath}`;
};
